<!--
 * @Autor: Baowang
 * @Date: 2024-11-20 13:57:32
 * @pageName: 注册弹框
 * @LastEditTime: 2024-11-20 16:37:54
-->
<template>
  <div class="login">
    <el-dialog :visible.sync="$store.state.registeredFable" :before-close="registeredClose" top="0">
      <div class="login_centent animate__animated animate__zoomIn">
        <div class="login_title">账号注册</div>
        <!-- 内容区域 -->
        <div class="acclogin">
          <div class="acclogin_input">
            <el-input v-model="mobile" placeholder="请输入手机号" maxLength="11"></el-input>
          </div>
          <div class="acclogin_input">
            <el-input v-model="captcha" placeholder="请输入验证码" maxLength="6">
              <template slot="suffix">
                <div class="input_count mouseGestures" @click="getCode">{{ downStr }}</div>
              </template>
            </el-input>
          </div>
          <div class="acclogin_input">
            <el-input v-model="password" show-password placeholder="请输入登录密码" maxLength="32"></el-input>
          </div>
          <div class="acclogin_input">
            <el-input v-model="password1" show-password placeholder="请输入登录密码" maxLength="32"></el-input>
          </div>
          <!-- 协议 -->
          <div class="xieyi_count" @click="clickAgreement">
            <img class="mouseGestures" src="../../assets/redio_y.png" alt="" v-if="$store.state.agreementFlag" />
            <img class="mouseGestures" src="../../assets/redio.png" alt="" v-else />
            <div class="xieyi_count_one">记得阅读并同意不止艺术</div>
            <div class="xieyi_count_one xieyi_count_two mouseGestures" @click.stop="goAgment(0)">
              服务条款
            </div>
            <div class="xieyi_count_one">和</div>
            <div class="xieyi_count_one xieyi_count_two mouseGestures" @click.stop="goAgment(1)">
              隐私政策
            </div>
          </div>
          <!-- 立即登录 -->
          <el-button class="auuountlogin mouseGestures" round @click="register">确认</el-button>
          <div class="register mouseGestures" @click="goLoginfable">
            已有账号？<span>去登录</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile: "",
      captcha: "",
      password: "",
      password1: "",
      isDisabled: false,
      downNum: 60, //倒计时
      downStr: '获取验证码',
    };
  },
  methods: {
    // 注册
    register() {
      if (!this.$store.state.agreementFlag) {
        this.$message.error('请先同意《用户协议》和《隐私政策》')
        return
      }
      if (this.mobile.length != 11) {
        this.$message.error('请输入正确的手机号')
        return
      }
      // if (this.captcha.length != 6) {
      //   this.$message.error('请输入正确的验证码')
      //   return
      // }
      if (this.password.length != 6) {
        this.$message.error('请输入正确的密码')
        return
      }
      if (this.password != this.password1) {
        this.$message.error('两次密码不一致')
        return
      }

      this.$api({
        url: "/api/user/register",
        method: "POST",
        data: {
          mobile: this.mobile,
          captcha: this.captcha,
          password: this.password
        }
      }).then((res) => {
        this.$message.success('注册成功')
        setTimeout(() => {
          this.sendCodeTime();
        }, 500)
      })
    },
    //获取验证码
    async getCode() {
      if (this.isDisabled) {
        return
      }
      let downStr = this.downStr; //验证标题
      if (downStr.indexOf("秒") != -1) {
        this.$message.error('正在发送验证码到手机，请耐心等待~');
        return;
      }
      if (this.mobile.length != 11) {
        this.$message.error('请输入正确的手机号')
        return;
      }

      this.$api({
        url: "/api/sms/send",
        method: "POST",
        data: {
          mobile: this.mobile,
          event: "register"
        }
      }).then((res) => {
        this.$message.success('验证码发送成功')
        this.sendCodeTime();
      })
    },
    //验证码倒计时
    sendCodeTime() {
      this.isDisabled = true; //将按钮置为不可点击
      this.downStr = this.downNum + '秒';
      let nums = parseInt(this.downNum);
      let that = this;
      let clock = setInterval(function () {
        nums--;
        if (nums > 0) {
          that.downStr = nums + '秒';
        } else {
          clearInterval(clock); //清除js定时器
          that.isDisabled = false;
          that.downStr = '重新发送';
          that.downNum = 60; //重置时间
        }
        this.downKey += 1;
      }, 1000);
    },
    // 点击协议
    clickAgreement() {
      this.$store.commit("updateAgreementFlag")
    },
    // 关闭弹框
    registeredClose() {
      this.$store.commit("updataRegistered", false);
    },
    // 关闭注册页，打开登录弹框
    goLoginfable() {
      this.registeredClose();
      this.$store.commit("updataLogin", true);
    },
    // 跳转协议
    goAgment(id) {
      this.registeredClose();
      this.$store.commit("updateAgemnt", id);
      this.$router.push({ name: "agemnt", query: { ids: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;

  /deep/ .el-dialog {
    border-radius: 20px;
    background: linear-gradient(to bottom, #fee8f6 20%, #ffffff 80%);
    width: 572px;
    height: 619px;
  }

  /deep/ .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-dialog__close {
    font-size: 30px;
  }

  .login_centent {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;

    .login_title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 32px;
      color: #29292b;
    }

    // 账号登录
    .acclogin {
      width: 100%;
      margin-top: 40px;

      .acclogin_input {
        width: 100%;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding: 0 5px;

        .el-input {
          height: 56px;
          background: #f7f8fa;
          border-radius: 28px;

          /deep/ .el-input__inner {
            height: 56px;
            line-height: 56px;
            border-radius: 28px;
            font-size: 18px;
          }

          /deep/ .show-password {
            font-size: 12px;
          }
        }

        .input_count {
          width: 120px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          background: #80d3be;
          border-radius: 22px;
          font-family: PingFang SC, PingFang SC;
          font-weight: normal;
          font-size: 16px;
          color: #ffffff;
          margin-top: 6px;
        }
      }

      .xieyi_count {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 20px 0;
        display: flex;
        align-items: center;

        img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }

        .xieyi_count_one {
          font-family: PingFang SC, PingFang SC;
          font-weight: normal;
          font-size: 14px;
          color: #67686c;
        }

        .xieyi_count_two {
          color: #3493ff;
          margin: 0 10px;
        }
      }

      // 立即登录
      .auuountlogin {
        width: 100%;
        height: 56px;
        border-radius: 56px;
        background-color: #80d3be;
        font-family: PingFang SC, PingFang SC;
        font-weight: normal;
        font-size: 20px;
        color: #ffffff;
        margin-top: 40px;
      }

      .fortPass {
        font-family: PingFang SC, PingFang SC;
        font-weight: normal;
        font-size: 16px;
        color: #67686c;
        width: 100%;
        text-align: center;
        margin-top: 10px;
      }

      .register {
        width: 100%;
        text-align: center;
        margin-top: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: normal;
        font-size: 16px;
        color: #29292b;

        span {
          color: #3493ff;
        }
      }
    }
  }
}
</style>
